// extracted by mini-css-extract-plugin
export default {"main":"Notification_main__+JwdY","container":"Notification_container__HrVcQ","boldText":"Notification_boldText__Htzj0"};